import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["src"];
import { ElDialog } from "element-plus";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImagePreviewDialog',
    props: {
        src: {}
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const isShown = ref(true);
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDialog), {
                "show-close": false,
                "append-to-body": true,
                "custom-class": 'image-preview-dialog',
                "align-center": true,
                modelValue: isShown.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isShown).value = $event)),
                onClosed: _cache[1] || (_cache[1] = ($event) => (emit('closed')))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("img", { src: _ctx.src }, null, 8 /* PROPS */, _hoisted_1)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
